import './styles.css'

export const CoverHeader = (
  {
    imageUrl,
    title,
    description,
    fillGradient
  }: {
    imageUrl?: string;
    title?: string;
    description?: string | null;
    fillGradient?: boolean;
  }
) => {
  return (
    <div className={"cover-header-container " + ((!imageUrl && fillGradient) ? "beauty-gradient" : "black-end-gradient")}>
      {imageUrl && <div className={"cover-header-image-background-container"}>
        <div
        className={"cover-header-image-background"}
        style={{backgroundImage: `url(${imageUrl})`}}
      ></div>
      </div>}
      {imageUrl && <div className={"cover-header-image"}>
        <img src={imageUrl} alt={"cover"}/>
      </div>}
      <div className={"cover-header-content"}>
        <div className={"cover-header-content-title"}>{title}</div>
        <div className={"cover-header-content-description"}>{description}</div>
      </div>
      <div className={"cover-header-gradient"}/>
    </div>
  );
}
